import { useState } from "react";
import { toast } from "react-toastify"; // Import toast for notifications
import axios from "axios"; // Import Axios
import { GetUser } from "../../Services";

const UpdateAccStatus = ({
  editingDriver,
  setEditingDriver,
  setDrivers,
  setShowModal,
}) => {
  const [accountStatus, setAccountStatus] = useState(
    editingDriver?.accountStatus || "PENDING",
  ); // Initialize with current status
  const driverId = editingDriver?.id;

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    console.log("update thingk", accountStatus);
    try {
      // Call the API to update the driver's account status
      // const response = await axios.put(
      //   `https://binberu.idaprocharity.com/api/v1/admin/update-driver-account-status/${driverId}/account-status`,
      //   {
      //     accountStatus,
      //   },
      // );

      // if (!window.confirm("Are you sure you want to delete this driver?"))
      //   return;

      // console.log("List", accountStatus);
      const data = await GetUser.UpdateDriverStatus(accountStatus, driverId);

      // Update the drivers list in the parent component using the local state value
      // (since the API response structure may not directly provide the updated status)
      setDrivers((prev) =>
        prev.map((driver) =>
          driver.id === driverId ? { ...driver, accountStatus } : driver,
        ),
      );

      // Clear the editing driver state
      setEditingDriver(null);

      // Show success toast
      toast.success("Account status updated successfully!");

      // Close the modal
      setShowModal(false);
    } catch (error) {
      console.error("Error updating account status:", error);
      // Show error toast
      toast.error("Failed to update account status. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <div
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "15px",
          borderRadius: "5px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="account_status" className="col-form-label">
              Status
            </label>
            <select
              id="account_status"
              name="account_status"
              value={accountStatus} // Bind the select value to accountStatus state
              onChange={(e) => setAccountStatus(e.target.value)} // Update state on change
              className="form-control"
            >
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="SUSPENDED">Suspended</option>
              <option value="BLOCKED">Blocked</option>
            </select>
          </div>
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateAccStatus;
